<template>
  <div class="tip-box" ref="topsBox">
    <p>{{ $t('敬请期待…') }}</p>
  </div>
</template>
<script>
import getTranslation from '@/locale/getTranslation'
export default {
  data() {
    return {}
  },
  created() {
    document.title = getTranslation('温馨提示')
  },
  mounted() {
    this.$refs['topsBox'].style.height =
      document.documentElement.clientHeight - 400 + 'px'
  }
}
</script>
<style lang="scss">
@media screen and (max-width: 800px) {
  .tip-box {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    min-height: 100vh;
    background: url('../assets/img-m/img-wait.png') center no-repeat;
    background-size: 100% auto;

    p {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      color: #fe8c01;
      font-size: 0.28rem;
      text-align: center;
      transform: translate(0, -4rem);
    }
  }
}
@media screen and (min-width: 800px) {
  .tip-box {
    position: relative;
    width: 1200px;
    min-height: 400px;
    margin: 0 auto;
    background: url('../assets/img-m/img-wait.png') center 30% no-repeat;
    background-size: 400px auto;

    p {
      position: absolute;
      left: 0;
      right: 0;
      top: 50%;
      color: #fe8c01;
      font-size: 14px;
      text-align: center;
      transform: translate(0, 8rem);
    }
  }
}
</style>
